export const invoiceConstants = {
  SAVE_INVOICES_LIST_URL: 'SAVE_INVOICES_LIST_URL',
  CLEAR_INVOICES_LIST_TABLE_DATA: 'CLEAR_INVOICES_LIST_TABLE_DATA',
  CLEAR_INVOICES_DATA: 'CLEAR_INVOICES_DATA',
  PATCH_INVOICES_LIST_ROW: 'PATCH_INVOICES_LIST_ROW',
  SET_INVOICES_LIST_REQUIRES_UPDATE: 'SET_INVOICES_LIST_REQUIRES_UPDATE',
};
